import Pemberitahuan from "./src/Pemberitahuan";

export default Pemberitahuan